import { combineReducers } from "redux";
import reader from "./persistent/reader";

export default combineReducers({
  reader
});
